module.exports = __webpack_public_path__ + "img/water06.566a32b6.png";